import { ConvexClient } from 'convex/browser';

let convexClient: ConvexClient | null = null;

function resolveConvexUrl(): string {
  const url = import.meta.env.PUBLIC_CONVEX_URL ?? import.meta.env.VITE_CONVEX_URL;
  if (!url) {
    throw new Error('Missing Convex deployment URL. Set PUBLIC_CONVEX_URL or VITE_CONVEX_URL.');
  }
  return url;
}

/**
 * The deployment's HTTP-action origin (…convex.site) — where http.ts routes
 * like /ics and /sentry-tunnel live, as opposed to the client API origin
 * (…convex.cloud).
 */
export function convexSiteUrl(): string {
  return resolveConvexUrl().replace('.convex.cloud', '.convex.site');
}

export function getConvex(): ConvexClient {
  if (!convexClient) {
    const url = resolveConvexUrl();
    convexClient = new ConvexClient(url);
  }
  return convexClient;
}

export function attachConvexAuth(getToken: () => Promise<string | null> | string | null) {
  const client = getConvex();
  client.setAuth(async () => {
    const token = await getToken();
    return token ?? null;
  });
}

export function resetConvexForTesting() {
  convexClient = null;
}
